/** Match backend TargetNormalization: trim + lowercase for domains / SecurityTrails. */
export function normalizeCaseTarget(target) {
  if (target == null || typeof target !== 'string') {
    return target;
  }
  return target.trim().toLowerCase();
}
